import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = ({ className = "", ...props }) => {
  const [show, setShow] = useState(false);
  const id = props["data-testid"] || "password";
  return (
    <div className="relative">
      <Input {...props} type={show ? "text" : "password"} className={`pr-11 ${className}`} />
      <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"}
              className="absolute right-1 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-slate-900 transition-colors"
              data-testid={`${id}-toggle`}>
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
